import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown";

type Items = {
  title: string;
  icon: string;
  onClick: () => void;
};

interface Props {
  items: Items[];
}

const DummyRowDropdown = ({ items }: Props) => (
  <span>
    <ButtonDropdown
      title={<span className="rioglyph rioglyph-option-vertical" />}
      variant="link"
      iconOnly
      pullRight
      items={items.map((i) => {
        return {
          value: (
            <a className="display-flex align-items-center gap-10 width-150" onClick={i?.onClick}>
              <span className={`${i?.icon} text-color-highlight `} />
              <span>{i?.title}</span>
            </a>
          ),
        };
      })}
    />
  </span>
);

export default DummyRowDropdown;
